import script from "./ExpansionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpansionPanel.vue?vue&type=script&setup=true&lang=js"

import "./ExpansionPanel.vue?vue&type=style&index=0&id=383fc9d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-383fc9d0"]])

export default __exports__